import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseMiniIcon } from '@calendly/ui/components/icons'
import { InlineSearch } from '@calendly/ui/components/inline-search'
import { PaginationFooter } from '@calendly/ui/components/pagination-footer'
import { LabelText } from '@calendly/ui/components/typography'

import { LayoutItem } from 'components/layout'

import { HostListItem } from './host_list_item'
import { UserPoolsList } from './user_pools_list'
import { filterByNameOrEmail } from '../../helpers'
import { useHostsListData, usePaginatedSearch, useRemoveMember } from '../../hooks'
import { ListWrapper } from '../styles'

const RelativeContainer = (props) => <LayoutItem relative {...props} />
const MemberNotFoundContainer = (props) => <LayoutItem padding="16" {...props} />

export const HostsList = ({
  eventType,
  userPool,
  isLocked,
  showHostsList = true,
  showUserPoolsList = false,
  skipPagination = false,
}) => {
  const { isSubmitting } = useFormContext()
  const removeMember = useRemoveMember(eventType)

  const {
    userPoolUid,
    isHostsEmpty,
    hosts,
    hasError,
  } = useHostsListData(userPool, eventType.isTeam)

  const {
    pageItems: pageHosts,
    showSearch,
    showSearchEmptyResult,
    showPagination,
    searchQuery,
    setSearchQuery,
    currentPage,
    openNextPage,
    openPrevPage,
    pageSize,
    totalCount
  } = usePaginatedSearch({
    items: hosts,
    filterFn: filterByNameOrEmail,
    skip: skipPagination
  })

  if (isHostsEmpty) {
    return (
      <UserPoolsList
        wrapped
        hidden={!showUserPoolsList}
        eventType={eventType}
        isLocked={isLocked}
      />
    )
  }

  return (
    <>
      {showSearch && (
        <RelativeContainer>
          <InlineSearch
            onChange={setSearchQuery}
            value={searchQuery}
            name="host_search"
            autoComplete="off"
            autoFocus
          />
        </RelativeContainer>
      )}
      <ListWrapper hasError={hasError} isLocked={isLocked}>
        {showHostsList && pageHosts.map((member, index) => (
          <HostListItem
            key={`${member.type}-${member.user_id || member.organization_invitation_id}`}
            index={member.formIndex || index}
            member={member}
            userPool={userPool}
            isLocked={isLocked}
            isMultiHost
            removeActionComponent={(
              <IconButton
                disabled={isSubmitting}
                onClick={() => removeMember(member, userPoolUid)}
                size="small"
                title={I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.remove')}
              >
                <CloseMiniIcon />
              </IconButton>
            )}
          />
        ))}
        {showSearchEmptyResult && (
          <MemberNotFoundContainer>
            <LabelText size="medium">
              {I18n.t('publisher.event_types.member_picker.not_found')}
            </LabelText>
          </MemberNotFoundContainer>
        )}
        <UserPoolsList
          hidden={!showUserPoolsList}
          eventType={eventType}
          isLocked={isLocked}
        />
      </ListWrapper>
      {showPagination && (
        <PaginationFooter
          currentPage={currentPage}
          onNextClick={openNextPage}
          onPreviousClick={openPrevPage}
          pageSize={pageSize}
          totalCount={totalCount}
        />
      )}
    </>
  )
}
